import {
  SET_DASHBOARD_FIELD,
  SET_DASHBOARD_FIELDS,
  ADD_INVESTMENT_TO_FAVORITES,
  ADD_INVESTMENTS_TO_FAVORITES,
  REMOVE_INVESTMENT_FROM_FAVORITES,
  PREV_BALANCE
} from './types'

const setDashboardFieldAction = payload => ({
  type: SET_DASHBOARD_FIELD,
  payload
})

const setDashboardFieldsAction = payload => ({
  type: SET_DASHBOARD_FIELDS,
  payload
})

const addInvestmentToFavoritesAction = payload => ({
  type: ADD_INVESTMENT_TO_FAVORITES,
  payload
})

const addInvestmentsToFavoritesAction = payload => ({
  type: ADD_INVESTMENTS_TO_FAVORITES,
  payload
})

const removeInvestmentFromFavoritesAction = payload => ({
  type: REMOVE_INVESTMENT_FROM_FAVORITES,
  payload
})

const setPrevBalanceAction = payload => ({
  type: PREV_BALANCE,
  payload
})

export {
  setDashboardFieldAction,
  setDashboardFieldsAction,
  addInvestmentToFavoritesAction,
  addInvestmentsToFavoritesAction,
  removeInvestmentFromFavoritesAction,
  setPrevBalanceAction
}
